import { render, staticRenderFns } from "./association.vue?vue&type=template&id=3d865980&scoped=true&"
import script from "./association.vue?vue&type=script&lang=js&"
export * from "./association.vue?vue&type=script&lang=js&"
import style0 from "./association.vue?vue&type=style&index=0&id=3d865980&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d865980",
  null
  
)

export default component.exports